import { useContext, useEffect, useState } from "react";
import { Button, Modal, Form, message, Select, Row, Col } from "antd";
import Moment from "react-moment";
import confirmBooking from "../../../../services/confirmBooking";
import { AuthContext } from "../../../../contexts/AuthContext";
import fetchDataTrace from "../../../../services/fetchDataTrace";
const { Option } = Select;

export default function ConfirmBooking({
  isVisible,
  selected,
  setConfirmModal,
  handleFetchBookings,
}: any) {
  const [form] = Form.useForm();

  const { user } = useContext(AuthContext);

  const isAdvisor = user?.role?.name === "Service Advisor" ? true : false;
  const [users, setUsers] = useState<any>([]);

  const handleFetchUsers = async () => {
    const uri = `users`;
    const response = await fetchDataTrace({ uri });
    const filtered = response?.payload.filter(
      (item: any) => item.role?.name === "Service Advisor" && item.isActive
    );
    setUsers(filtered);
  };

  const onSubmit = async () => {
    let { assignedTo } = form.getFieldsValue();
    if (isAdvisor) {
      assignedTo = user?._id;
    }

    const data = {
      status: "Confirmed",
      name: selected?.customer_name,
      mobile: selected?.customer_mobile,
      is_confirmed: true,
      assignedTo,
    };
    const booking_id = selected._id;

    const response = await confirmBooking(data, booking_id);
    if (response.success) {
      message.success("Confirmed successfully");
    } else {
      message.error(response?.message);
    }
    setConfirmModal(false);
    await handleFetchBookings();
  };

  const hideModal = () => {
    setConfirmModal(false);
  };

  const userOptions = users?.map((user: any, index: number) => (
    <Option value={user?._id} key={index}>
      {user?.firstname} {user?.lastname}
    </Option>
  ));

  useEffect(() => {
    form.resetFields();
    handleFetchUsers();
  }, [selected]);

  return (
    <Modal
      visible={isVisible}
      title="Confirm Booking"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="ConfirmBooking"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
        >
          Confirm
        </Button>,
      ]}
    >
      <Form
        id="ConfirmBooking"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <div className="pb-4">
          <div className="flex text-black font-bold text-lg">
            VEHICLE: {selected?.title}
          </div>
          <div className="flex ">
            <span className="w-12">Date: </span>
            <Moment format="Do MMM, YYYY">{selected?.date}</Moment>
          </div>
          <div className="flex ">
            <span className="w-12">Time : </span>
            <Moment format="HH:mm A">{selected?.slottime?.starttime}</Moment>
            <div className="mx-2">-</div>
            <Moment format="HH:mm A">{selected?.slottime?.endtime}</Moment>
          </div>
        </div>
        <div className="">Booking No. {selected?.bookingno}</div>

        {isAdvisor ? null : (
          <Row gutter={[16, 0]}>
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
              <Form.Item
                name="assignedTo"
                label="Assign To"
                rules={[
                  {
                    required: true,
                    message: "Please select assignee",
                  },
                ]}
              >
                <Select placeholder="Assign To">{userOptions}</Select>
              </Form.Item>
            </Col>
          </Row>
        )}
      </Form>
    </Modal>
  );
}
